export enum DoorHanding {
    Unspecified = 0,
    Right = 1,
    Left = 2,
}

